export const links = [
    {
        name: "Home",
        path: "/",
        color: "yellow"
    },
    {
        name: "About",
        path: "/about"
    },
    {
        name: "Dashboard",
        path: "/dashboard"
    },
    {
        name: "Services",
        path: "/services"
    },
    {
        name: "Contact",
        path: "/contact"
    },
]

export const LoginLinks = [
    {
        name: "Login",
        path: "/login"
    },
    {
        name: "Register",
        path: "/register",
        
    },
]